export const env = {
    envName: "DEV",
    production: false,
    test: false,
    applicationName: "chatAi",
    defaultLanguage: "en",
    cryptoKey: process.env.REACT_APP_AUTH_TOKEN,
    baseURL:process.env.REACT_APP_BASE_URL
} 